import { RequestCuote, CuoteResponse, ManageQuote, SolutionResponse, WaitingSolution, FinishResponse } from "./Components";
import { NoHistorial } from "../../../../../../../../components/errors/noHistorial";
import { useParams } from "react-router-dom";
import { useGetData } from "../../hooks/useGetData";
import { getLocalStorage, LocaleNameType } from "../../../../../../../../utils/crud/crypt";
import { useState, useCallback, useEffect } from "react";
import { Box, CircularProgress } from "@mui/material";
import { Status } from "../../../../../../../../utils/enums";

export const HistoryReportFolio = ({ onAttend, historial, left, isLoading, getHistorial }) => {
    const [isReloading, setIsReloading] = useState(false);

    const reload = useCallback(async () => {
        if (isReloading) return;
        setIsReloading(true);
        try {
            await getHistorial();
        } finally {
            setIsReloading(false);
        }
    }, [isReloading, getHistorial]);

    const renderStepItem = useCallback((item) => {
        const commonProps = {
            key: item.id,
            items: [item],
            reload,
            onAttend,
            left,
            disabled: (left.status.id == Status.NOT_FINISHED || left.status.id == Status.EXPIRED) ? true : false
        };

        switch (item.newStep) {
            case "MANAGE_QUOTE":
            case "MANAGE_SOLUTION":
                return <ManageQuote {...commonProps} />;
            case "REQUEST_QUOTES":
                return <RequestCuote {...commonProps} />;
            case "SOLUTION":
                return <SolutionResponse {...commonProps} />;
            case "WAITING":
                return <WaitingSolution {...commonProps} />;
            case "QUOTE":
                return <CuoteResponse {...commonProps} />;
            default:
                return null;
        }
    }, [reload, onAttend]);

    if (isLoading || isReloading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box sx={{ width: '100%' }}>
            {historial?.items?.length > 0 ? (
                <Box sx={{ width: '100%' }}>
                    {historial.items.map(renderStepItem)}
                </Box>
            ) : (
                <NoHistorial
                    label="No hay historial disponible"
                    footer="Contacta al encargado"
                />
            )}
        </Box>
    );
};